import type * as ngCore from '@angular/core'

import * as routeBound from '../route-bound'

import * as adjustmentLabels from './adjustment-labels'
import * as allocationDistributions from './allocation-distributions'
import * as exclusionLabels from './exclusion-labels'
import * as gl from './gl'
import * as faFunctions from './idc-functions'
import * as reports from './reports'

export {
  adjustmentLabels,
  allocationDistributions,
  exclusionLabels,
  faFunctions,
  gl,
  reports,
}

export function provideEntityCollections(): ngCore.Provider[] {
  return [
    adjustmentLabels.Api,
    routeBound.Registry.provideDestroyable(adjustmentLabels.Collection),
    allocationDistributions.Api,
    routeBound.Registry.provideDestroyable(allocationDistributions.Collection),
    exclusionLabels.Api,
    routeBound.Registry.provideDestroyable(exclusionLabels.Collection),
    faFunctions.categories.Api,
    routeBound.Registry.provideDestroyable(faFunctions.categories.Collection),
    faFunctions.subcategories.Api,
    routeBound.Registry.provideDestroyable(
      faFunctions.subcategories.Collection,
    ),
    gl.mappingEntries.Api,
    routeBound.Registry.provideDestroyable(gl.mappingEntries.Collection),
    gl.records.Api,
    routeBound.Registry.provideDestroyable(gl.records.Collection),
    gl.rules.Api,
    routeBound.Registry.provideDestroyable(gl.rules.Collection),
    reports.Api,
    routeBound.Registry.provideDestroyable(reports.Collection),
  ]
}
